import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiType, FiHash, FiBook, FiClock } = FiIcons;

const STATS = [
  { icon: FiType, label: 'Characters', key: 'chars' },
  { icon: FiHash, label: 'Words', key: 'words' },
  { icon: FiBook, label: 'Est. Pages', key: 'pages' },
  { icon: FiClock, label: 'Read Time', key: 'time' },
];

export default function StatsBar({ stats }) {
  return (
    <div className="bg-gradient-to-r from-indigo-50 to-violet-50 border-b border-indigo-100 shrink-0">
      <div className="flex items-stretch divide-x divide-indigo-100 overflow-x-auto no-scrollbar">
        {STATS.map(({ icon, label, key }) => (
          <div key={key} className="flex flex-col items-center justify-center px-5 py-2.5 min-w-[90px] flex-1">
            <SafeIcon icon={icon} className="text-indigo-400 text-xs mb-0.5" />
            <span className="text-sm font-black text-slate-800 leading-tight">{stats[key]}</span>
            <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}